import React from "react"
import { Link } from "react-router-dom"
import { Nav, NavItem } from "reactstrap"
import classnames from "classnames"
import PropTypes from "prop-types"

import "./SecondaryNav.scss"

const SecondaryNav = props => (
  <div className="SecondaryNav">
    <Nav>
      {props.tabs.map((tab, i) => {
        if (props.disabledLinks && props.disabledLinks.includes(tab.label)) {
          return (
            <div key={i} className="inactive-tab">
              {tab.label}
            </div>
          )
        } else {
          return (
            <NavItem key={i}>
              <Link
                key={i}
                to={tab.path}
                className={classnames({
                  "nav-link": true,
                  active: props.activeTab === tab.label,
                })}
              >
                {tab.label}
              </Link>
            </NavItem>
          )
        }
      })}
    </Nav>
  </div>
)

SecondaryNav.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({ label: PropTypes.string, path: PropTypes.string })
  ),
  activeTab: PropTypes.string.isRequired,
  disabledLinks: PropTypes.arrayOf(PropTypes.string.isRequired),
}

export default SecondaryNav
